import React, { useContext } from 'react';
import { getPath } from '@express-labs/raven-tools';

import MyInsiderIDModal from './MyInsiderIDModal';
import { MAX_MOBILE_ONLY_WIDTH, TIER_STATIC_CONFIGS, DEFAULT_TIER } from '../../../../../../constants';
import getFromStorage from '../../../../../../helpers/storage/storage';
import { ResizeContext } from '../../../../../../contexts/Resize/Resize';

export function sanitizeTierName(tierName) {
  return tierName ? tierName.toLowerCase().replace(/\s|-/g, '') : 'insider';
}

export function getTierConfig(tierName) {
  if (tierName && TIER_STATIC_CONFIGS[tierName]) {
    return TIER_STATIC_CONFIGS[tierName];
  }
  return TIER_STATIC_CONFIGS[DEFAULT_TIER];
}

export function getTierDescriptionComponent(
  tierName,
  {
    nextTierName, tierExpirationDate, pointsToNextTier, pointsToRetainTier,
  },
) {
  switch (tierName) {
    case 'vip': {
      return (
        <>
          Your VIP status will expire on
          {` ${tierExpirationDate}.`}
        </>
      );
    }
    case 'alist': {
      return (
        <>
          Earn
          {' '}
          <strong>{` ${pointsToRetainTier} `}</strong>
          points by
          {` ${tierExpirationDate} `}
          <br />
          to keep your A-List status.
        </>
      );
    }
    case 'influencer':
    case 'insider':
    default:
      return (
        <>
          You&apos;re
          {' '}
          <strong>{pointsToNextTier}</strong>
          {' '}
          points away from
          {' '}
          {nextTierName}
          {' '}
          status.
        </>
      );
  }
}

export function getSubtitleAndBenefits(isECCHolderAccount, tierConfig) {
  if (isECCHolderAccount) {
    return {
      tierBenefits: getPath(tierConfig, 'isECCHolderTierBenefits', []),
      tierBenefitsTitle: 'Your CardMember Benefits',
      tierSubtitle: 'CREDIT CARDMEMBER',
    };
  }
  return {
    tierBenefits: getPath(tierConfig, 'tierBenefits', []),
    tierBenefitsTitle: 'Your Benefits',
    tierSubtitle: '',
  };
}

function MyInsiderIDModalVM(props) {
  const { width } = useContext(ResizeContext);
  const loyaltyWarmStateData = getFromStorage('loyaltyWarmStateData', {});
  let tierName = getPath(loyaltyWarmStateData, 'tierName', '');
  tierName = tierName === 'A List' ? 'A-List' : tierName;
  const sanitizedTierName = sanitizeTierName(tierName);
  const loyaltyId = loyaltyWarmStateData.loyaltyNumber || '';
  const deviceWidth = width <= MAX_MOBILE_ONLY_WIDTH ? 'mobile' : 'desktop';
  // Data for tiers
  const tierConfig = getTierConfig(sanitizedTierName);
  const tierIcon = deviceWidth === 'mobile'
    ? getPath(tierConfig, 'tierMobileIcon', '')
    : getPath(tierConfig, 'tierDesktopIcon', '');
  const nextTierName = getPath(tierConfig, 'nextTier.name', '');
  const isECCHolderAccount = getPath(loyaltyWarmStateData, 'nextCreditCardHolder', false);
  const tierExpirationDate = getPath(loyaltyWarmStateData, 'tierExpirationDate', '');
  const pointsToNextTier = getPath(loyaltyWarmStateData, 'pointsToNextTier', '');
  const pointsToRetainTier = getPath(loyaltyWarmStateData, 'pointsToRetainCurrentTier', '');
  const tierDescription = getTierDescriptionComponent(sanitizedTierName, {
    nextTierName,
    tierExpirationDate,
    isECCHolderAccount,
    pointsToNextTier,
    pointsToRetainTier,
  });
  const { tierBenefitsTitle, tierSubtitle, tierBenefits } = getSubtitleAndBenefits(
    isECCHolderAccount,
    tierConfig,
  );

  return (
    <MyInsiderIDModal
      tierName={tierName}
      loyaltyNumber={loyaltyId}
      tierBenefits={tierBenefits}
      tierBenefitsTitle={tierBenefitsTitle}
      tierDescription={tierDescription}
      tierIcon={tierIcon}
      tierSubtitle={tierSubtitle}
      version={deviceWidth}
      {...props}
    />
  );
}

export default React.memo(MyInsiderIDModalVM);
